// @TODO: should this be moved outside of ClassroomGoal?
// @TODO: need this component anymore?
/*
 * Ryan O'Dowd
 * 2024-03-10
 * © Copyright 2024 Oakwood Software Consulting, Inc. All Rights Reserved.
 */
import React, {
  useState,
} from 'react';
import {
  DatePickerModal,
} from 'react-native-paper-dates';
import FormControl from '@components/common/FormControl';
import IconButton from '@components/common/IconButton';
import TextInput from '@components/common/TextInput';
import Tooltip from '@components/common/Tooltip';
import {
  View,
} from 'react-native';
import {
  format as dateFnsFormat,
} from 'date-fns';
import getStyles from './styles';
import hooks from '@hooks';

const DATE_FORMAT = 'MMMM d, yyyy';

const DateRange = (props: DateRangeProps) => {
  const styles = hooks.useStyles(getStyles);

  const [_isDateAvailableOpen, setIsDateAvailableOpen] = useState(false);
  const [_isDateDeadlineOpen, setIsDateDeadlineOpen] = useState(false);

  return (
    <FormControl.Row style={styles.container}>
      <View style={styles.pickerAndButtonWrapper}>
        <View style={styles.pickerWrapper}>
          <TextInput
            label='Date available'// @TODO: i18n
            mode='outlined'
            value={props.dateAvailable ? dateFnsFormat(new Date(props.dateAvailable), DATE_FORMAT) : null}
            onFocus={() => setIsDateAvailableOpen(true)}// @TODO: not working
            right={!props.hideClear &&// @TODO: maybe this should be left, and right is calendar icon?
              <Tooltip title='Clear available from date'>
                <IconButton
                  icon='close'
                  iconColor={styles.colors.primary}
                  onPress={() => props.setDateAvailable(null)}
                />
              </Tooltip>
            }
          />
          <DatePickerModal
            locale='en'
            mode='single'
            label='Date available'// @TODO: i18n
            visible={_isDateAvailableOpen}
            onDismiss={() => setIsDateAvailableOpen(false)}
            date={props.dateAvailable}
            onConfirm={(res) => {
              props.setDateAvailable(res.date);
              setIsDateAvailableOpen(false);
            }}
            // @TODO: need this? startYear={new Date().getFullYear()}
            validRange={{// @TODO: not working for new goal
              startDate: props.minDateAvailable,
              endDate: props.maxDateAvailable,
            }}
          />
        </View>
      </View>
      <View style={styles.pickerAndButtonWrapper}>
        <View style={styles.pickerWrapper}>
          <TextInput
            label='Date deadline'// @TODO: i18n
            mode='outlined'
            value={props.dateDeadline ? dateFnsFormat(new Date(props.dateDeadline), DATE_FORMAT) : null}
            onFocus={() => setIsDateDeadlineOpen(true)}// @TODO: not working
            right={!props.hideClear &&// @TODO: maybe this should be left, and right is calendar icon?
              <Tooltip title='Clear due date'>
                <IconButton
                  icon='close'
                  iconColor={styles.colors.primary}
                  onPress={() => props.setDateDeadline(null)}
                />
              </Tooltip>
            }
          />
          <DatePickerModal
            locale='en'
            mode='single'
            label='Date deadline'// @TODO: i18n
            visible={_isDateDeadlineOpen}
            onDismiss={() => setIsDateDeadlineOpen(false)}
            date={props.dateDeadline}
            onConfirm={(res) => {
              props.setDateDeadline(res.date);
              setIsDateDeadlineOpen(false);
            }}
            // @TODO: need this? startYear={new Date().getFullYear()}
            validRange={{// @TODO: not working for new goal
              startDate: props.minDateDeadline,
              endDate: props.maxDateDeadline,
            }}
          />
        </View>
      </View>
    </FormControl.Row>
  );
};

class DateRangeProps {
  setDateAvailable: (newValue: Date | null) => void;
  setDateDeadline: (newValue: Date | null) => void;

  headerRight?: React.ReactNode;
  dateAvailable?: any;
  dateDeadline?: any;
  minDateAvailable?: any;
  maxDateAvailable?: any;
  minDateDeadline?: any;
  maxDateDeadline?: any;
  hideClear?: boolean;
};

export default DateRange;
